import { ResearchTag } from '../types/Research'

/**
 * Helper function to get tag names from tag IDs
 */
export const getTagNames = (
  tagIds: string[],
  tags: ResearchTag[]
): string[] => {
  return tagIds.map((id) => tags.find((tag) => tag.id === id)?.name || id)
}

/**
 * Helper function to truncate text
 */
export const truncateText = (text: string, maxLength: number = 200): string => {
  if (text.length <= maxLength) return text
  return text.substring(0, maxLength) + '...'
}

/**
 * Helper function to format dates consistently
 */
export const formatDate = (date: Date): string => {
  return date.toLocaleDateString()
}
